if (!customElements.get("td-featured-combined-listing")) {
  class TdFeaturedCombinedListing extends HTMLElement {
    constructor() {
      super();     
      // Get all product items
      this.productItems = this.querySelectorAll('.td-apps-item');
      // Get the forms
      this.subscriptionForm = document.querySelector('.product-form:not(.td-product__buy-once-wrapper .product-form) form');
      this.onetimeForm = document.querySelector('.td-product__buy-once-wrapper .product-form form');
      // Get the buttons
      this.subscriptionButton = document.querySelector('.th-single-add-to-cart-button');
      this.onetimeButton = document.querySelector('.td-product__buy-once-button');
      // Get price elements
      this.subscriptionPrice = this.subscriptionButton?.querySelector('[data-atc-price]');
      this.onetimePrice = this.onetimeButton?.querySelector('.th-add-to-cart-price');
      // Store the current active product
      this.activeProduct = null;
      // Get sticky ATC component
      this.stickyATC = document.querySelector('th-sticky-atc');
      this.ICON_LIST_ITEM_SELECTOR = "[data-th-shipping-estimate]";
    }

    connectedCallback() {
      // Add click event listeners to all product items
      this.productItems.forEach(item => {
        item.addEventListener('click', () => this.handleProductClick(item));
      });

      // Add click listeners to buttons
      if (this.subscriptionButton) {
        this.subscriptionButton.addEventListener('click', (e) => this.handleSubscriptionClick(e));
      }
      if (this.onetimeButton) {
        this.onetimeButton.addEventListener('click', (e) => this.handleOnetimeClick(e));
      }

      // Listen for product selection from sticky ATC
      document.addEventListener('sticky-atc-product-selected', (e) => this.handleStickyATCProductSelection(e));
      this.addIconListShippingText();

      // Set up initial state
      const initialActiveProduct = this.querySelector('.td-apps-item.td-active');
      if (initialActiveProduct) {
        this.handleProductClick(initialActiveProduct);
      } else {
        // If no active product is set, set the first one as active and handle free gift
        if (this.productItems.length > 0) {
          this.handleProductClick(this.productItems[0]);
        }
      }
    }

    handleStickyATCProductSelection(event) {
      const { variantId, sellingPlanId } = event.detail;
      
      // Find the matching product item using just variantId and sellingPlanId
      const matchingItem = Array.from(this.productItems).find(item => 
        item.dataset.variantId === variantId && 
        item.dataset.sellingPlanId === sellingPlanId
      );

      if (matchingItem) {
        this.handleProductClick(matchingItem);
      }
    }

    handleProductClick(clickedItem) {
      // Remove td-active class from all items
      this.productItems.forEach(item => {
        item.classList.remove('td-active');
      });

      // Add td-active class to clicked item
      clickedItem.classList.add('td-active');

      // Store the active product
      this.activeProduct = clickedItem;

      // Handle free gift visibility
      this.updateFreeGiftVisibility(clickedItem);

      // Update both forms with the selected product's variant ID
      if (this.subscriptionForm) {
        const variantId = clickedItem.dataset.variantId;
        const variantInput = this.subscriptionForm.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = variantId;
        }
      }
      if (this.onetimeForm) {
        const variantId = clickedItem.dataset.variantId;
        const variantInput = this.onetimeForm.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = variantId;
        }
      }

      // Update prices
      this.updatePrices(clickedItem);

      // Update the sticky ATC
      if (this.stickyATC) {
        const select = this.stickyATC.querySelector('select');
        if (select) {
          const matchingOption = Array.from(select.options).find(option => 
            option.dataset.variantId === clickedItem.dataset.variantId && 
            option.dataset.sellingPlanId === clickedItem.dataset.sellingPlanId
          );

          if (matchingOption) {
            select.value = matchingOption.value;
            select.dispatchEvent(new Event('change'));
          }
        }
      }
    }

    updateFreeGiftVisibility(productItem) {
      // Find or create the free gift element
      let freeGiftElement = document.querySelector('.td-pps__free-gift');
      
      // If free gift element doesn't exist, create it
      if (!freeGiftElement) {
        freeGiftElement = document.createElement('div');
        freeGiftElement.className = 'td-pps__free-gift';
        freeGiftElement.style.display = 'none';
        
        // Insert it after the product selector
        const productSelector = document.querySelector('.td-alt-product-pack-selector');
        if (productSelector) {
          productSelector.parentNode.insertBefore(freeGiftElement, productSelector.nextSibling);
        }
      }
      
      // Check if the selected product has a free gift
      const hasFreeGift = productItem.dataset.productId && 
                         productItem.dataset.freeGift === 'true';
      
      if (hasFreeGift) {
        // Update the free gift content based on the selected product
        this.updateFreeGiftContent(freeGiftElement, productItem);
        freeGiftElement.style.display = '';
      } else {
        freeGiftElement.style.display = 'none';
      }
    }

    updateFreeGiftContent(freeGiftElement, productItem) {
      // Get free gift data from the product item's data attributes
      const freeGiftImage = productItem.dataset.freeGiftImage;
      const freeGiftText = productItem.dataset.freeGiftText;
      
      // Clear existing content
      freeGiftElement.innerHTML = '';
      
      // Create image element if we have image data
      if (freeGiftImage) {
        const imageWrapper = document.createElement('div');
        imageWrapper.className = 'td-pps__free-gift-image';
        
        const img = document.createElement('img');
        img.src = freeGiftImage;
        img.alt = 'Free gift';
        
        imageWrapper.appendChild(img);
        freeGiftElement.appendChild(imageWrapper);
      }
      
      // Create text element if we have text data
      if (freeGiftText) {
        const textElement = document.createElement('p');
        textElement.className = 'td-pps__free-gift-text';
        textElement.textContent = freeGiftText;
        freeGiftElement.appendChild(textElement);
      }
    }

    updatePrices(productItem) {
      // Get prices from data attributes
      const subscriptionPrice = productItem.dataset.subscriptionPrice;
      const regularPrice = productItem.dataset.regularPrice;

      // Update subscription button price
      if (this.subscriptionPrice && subscriptionPrice) {
        this.subscriptionPrice.textContent = subscriptionPrice;
      }

      // Update one-time button price
      if (this.onetimePrice && regularPrice) {
        this.onetimePrice.textContent = `for ${regularPrice}`;
      }
    }

    handleSubscriptionClick(e) {
      if (!this.activeProduct) return;

      e.preventDefault();
      
      // Get the selling plan ID from the active product
      const sellingPlanId = this.activeProduct.dataset.sellingPlanId;
      
      // Update the form with the selling plan ID
      if (this.subscriptionForm) {
        // Remove any existing selling plan input
        const existingSellingPlan = this.subscriptionForm.querySelector('input[name="selling_plan"]');
        if (existingSellingPlan) {
          existingSellingPlan.remove();
        }

        // Add the selling plan input
        const sellingPlanInput = document.createElement('input');
        sellingPlanInput.type = 'hidden';
        sellingPlanInput.name = 'selling_plan';
        sellingPlanInput.value = sellingPlanId;
        this.subscriptionForm.appendChild(sellingPlanInput);

        // Submit the form
        this.subscriptionForm.submit();
      }
    }

    handleOnetimeClick(e) {
      if (!this.activeProduct) return;

      e.preventDefault();
      
      // Remove any existing selling plan input
      if (this.onetimeForm) {
        const existingSellingPlan = this.onetimeForm.querySelector('input[name="selling_plan"]');
        if (existingSellingPlan) {
          existingSellingPlan.remove();
        }

        // Submit the form
        this.onetimeForm.submit();
      }
    }

    addIconListShippingText() {
      let estimatedDate = '';
      document.querySelectorAll(this.ICON_LIST_ITEM_SELECTOR).forEach((item) => {
        function getMonthName(monthNumber) {
          const date = new Date();
          date.setMonth(monthNumber - 1);
          return date.toLocaleString('en-US', { month: 'long' });
        }

        const shippingDays = parseInt(item.dataset.thShippingEstimate);
        let date = new Date();
        date.setDate(date.getDate() + shippingDays);
        estimatedDate = `${getMonthName(date.getMonth() + 1)} ${date.getDate()}`;
        if (!estimatedDate) {return}
        item.innerHTML = `
        <span class="th-shipping-estimate">${estimatedDate}</span>
        `
      });
    }

  }

  customElements.define("td-featured-combined-listing", TdFeaturedCombinedListing);
}
